<template>
	<div>
		<v-tabs v-model="activeTab" icons-and-text slider-color="white" color="transparent">
			<v-tabs-slider color="primary"></v-tabs-slider>

			<v-tab>
				Assets
				<v-icon>mdi-cellphone-link</v-icon>
			</v-tab>

			<v-tab>
				Locations
				<v-icon>mdi-map-marker</v-icon>
			</v-tab>

			<v-tab>
				Categories
				<v-icon>mdi-ungroup</v-icon>
			</v-tab>

			<v-tab-item>
				<v-card flat>
					<assets-list />
				</v-card>
			</v-tab-item>
			<v-tab-item>
				<v-card flat>
					<asset-locations-list />
				</v-card>
			</v-tab-item>
			<v-tab-item>
				<v-card flat>
					<asset-categories-list />
				</v-card>
			</v-tab-item>
		</v-tabs>
	</div>
</template>

<script>
	import AssetsList from '@/components/assets/AssetsList';
	import AssetCategoriesList from '@/components/assets/AssetCategoriesList';
	import AssetLocationsList from '@/components/assets/AssetLocationsList';
	import { mapGetters } from 'vuex';

	export default {
		components: {
			AssetsList,
			AssetCategoriesList,
			AssetLocationsList
		},
		data() {
			return {
				activeTab: 0,
				selected: []
			};
		},
		async created() {
			await this.$store.dispatch('setPageTitle', 'Assets');

			if (!this.hasLoadedAssets) {
				await this.$store.dispatch('assets/get');
			}

			if (!this.hasLoadedAssetConfiguration) {
				await this.$store.dispatch('assetConfiguration/get');
			}
		},
		computed: {
			...mapGetters({
				hasLoadedAssets: 'assets/hasLoaded',
				hasLoadedAssetConfiguration: 'assetConfiguration/hasLoaded'
			})
		}
	};
</script>
